export default __webpack_public_path__ + "static/media/Cary-Katz.5722af3d.png";